import { useTranslation } from "react-i18next";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { Button, Card, Flex, Select, Space, Spin } from "antd";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";
import { enmExportStatus } from "../../models/enums/ExportStatus";
import { useMutation, useQuery } from "react-query";
import { mdlActionTemplateListRequest } from "../../models/service-models/action/ActionTemplateListRequest";
import { useEffect, useState } from "react";
import { ActionService } from "../../services/ActionService";
import { ActionTemplateTable } from "../../components/action/ActionTemplateTable";
import { mdlPDFRendererProps } from "../../models/ui-models/PDFRendererProps";
import { enmPdfRendererType } from "../../models/enums/PdfRenderer";
import { enmPdfExportType } from "../../models/enums/PdfExportType";
import { setPdfExportObject } from "../../store/SiteSlice";
import { SFModal } from "../../components/elements/SFModal";
import ActionMail from "../../components/action/ActionMail";
import { ExpandableActionDetailTable } from "../../components/action/ExpandableActionDetailTable";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { mdlSpoMailPreviewRequest } from "../../models/service-models/action/SpoMailPreviewRequest";
import { mdlSpoCancelRequest } from "../../models/service-models/action/SpoCancelRequest";
import { mdlSpoSendRequest } from "../../models/service-models/action/SpoSendRequest";

export const ActionHistory = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const exportStatus = useAppSelector(x => x.site.exportStatus);
    const printStatus = useAppSelector(x => x.site.printStatus);
    const [templateListRequest, setTemplateListRequst] = useState<mdlActionTemplateListRequest>({ echo: 1, type: 1, displayLength: 10, displayStart: 0 });
    const [openMailModal, setOpenMailModal] = useState<boolean>(false);
    const [selectedSpo, setSelectedSpo] = useState<string>();
    const [triggerSource, setTriggerSource] = useState<enmPdfExportType>();

    const {
        data,
        isLoading,
        refetch
    } = useQuery(
        ["getActionTemplates", templateListRequest],
        () => {
            if (templateListRequest)
                return ActionService.SimpleSpoList(templateListRequest);

        },
        {
            refetchOnWindowFocus: false,
            enabled: !!templateListRequest,
        }
    );

    const {
        data: mailPreviewData,
        isLoading: mailPreviewLoading
    } = useQuery(
        ["getSpoMailPreview", selectedSpo],
        () => {
            if (selectedSpo) {
                var request: mdlSpoMailPreviewRequest = { spoId: selectedSpo };
                return ActionService.MailPreview(request);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedSpo
        }
    );

    useEffect(() => {
        if (triggerSource && selectedSpo && mailPreviewData) {
            switch (triggerSource) {
                case enmPdfExportType.PDF:
                    handleExport(selectedSpo);
                    break;
                case enmPdfExportType.PRINT:
                    handlePrint(selectedSpo);
                    break;
            }
        }
    }, [triggerSource, mailPreviewData])

    const { mutateAsync: cancelAction, isLoading: mutateLoading, data: mutateData } = useMutation(
        (request: mdlSpoCancelRequest) => ActionService.Cancel(request),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    send({ spoId: data.body?.message });
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const { mutateAsync: send, isLoading: sendLoading, data: sendData } = useMutation(
        (request: mdlSpoSendRequest) => ActionService.Send(request),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    refetch();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    const handleCancel = (id: string) => {
        cancelAction({ spoId: id })
    }

    const handleExport = (id: string) => {
        if (triggerSource == enmPdfExportType.PDF && selectedSpo == id && mailPreviewData) {
            let params = {};
            params = { htmlContent: mailPreviewData?.body?.data?.previewHTML }
            var exportProps: mdlPDFRendererProps = {
                params: params,
                rendererType: enmPdfRendererType.ActionTemplate,
                type: enmPdfExportType.PDF,
            }
            setTriggerSource(undefined);
            setSelectedSpo(undefined);
            dispatch(setPdfExportObject(exportProps));
        } else {
            setTriggerSource(enmPdfExportType.PDF);
            setSelectedSpo(id);
        }
    }

    const handlePrint = (id: string) => {
        if (triggerSource == enmPdfExportType.PRINT) {
            let params = {};
            params = { htmlContent: mailPreviewData?.body?.data?.previewHTML }
            var exportProps: mdlPDFRendererProps = {
                params: params,
                rendererType: enmPdfRendererType.ActionTemplate,
                type: enmPdfExportType.PRINT,
            }
            setTriggerSource(undefined);
            setSelectedSpo(undefined);
            dispatch(setPdfExportObject(exportProps));
        }
        else {
            setTriggerSource(enmPdfExportType.PRINT);
            setSelectedSpo(id);
        }
    }

    const handleMail = (spoId: string) => {
        setSelectedSpo(spoId);
        setOpenMailModal(true);
    }

    const handleMailCallback = () => {
        setOpenMailModal(false);
        refetch();
    }

    const handleExpandRowRenderer = (id: string) => {
        return <ExpandableActionDetailTable id={id} />;
    }


    const handleDisplaySizeChange = (size: string) => {
        setTemplateListRequst({ ...templateListRequest, ["displayLength"]: Number(size) });
    }
    let pageSizes: { name: string; id: number }[] = [{ id: 10, name: "10" }, { id: 25, name: "25" }, { id: 50, name: "50" }, { id: 100, name: "100" }]

    return (
        <>
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("action.history.title")}
                            />
                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-12">
                                        <Spin spinning={exportStatus != enmExportStatus.DONE || printStatus != enmExportStatus.DONE}>
                                            <Card loading={isLoading || mutateLoading || sendLoading}>
                                                <div className="card-inner">
                                                    <Flex justify="space-between">
                                                        <Space direction="vertical">
                                                            <Flex>
                                                                <Space direction="horizontal">
                                                                    <label>{t("action.template.displaySize")}</label>
                                                                    <Select
                                                                        size="middle"
                                                                        onFocus={onFocus}
                                                                        value={templateListRequest && templateListRequest.displayLength ? templateListRequest.displayLength.toString() : "10"}
                                                                        onChange={handleDisplaySizeChange}
                                                                        placeholder={t("common.displaySize")}
                                                                        options={pageSizes?.map(h => Object.assign(h, {
                                                                            label: h.name,
                                                                            value: h.id
                                                                        }))}
                                                                    />
                                                                </Space>
                                                            </Flex>
                                                        </Space>
                                                    </Flex>
                                                    <Flex vertical>
                                                        <ActionTemplateTable
                                                            cancelActive={true}
                                                            onDelete={handleCancel}
                                                            onExport={handleExport}
                                                            onPrint={handlePrint}
                                                            onSendMail={handleMail}
                                                            expandRowRenderer={handleExpandRowRenderer}
                                                            dataSource={data?.body?.data}
                                                        />
                                                        <Flex justify="end">
                                                            <Button onClick={() => setTemplateListRequst({ ...templateListRequest, ["echo"]: templateListRequest.echo! - 1, ["displayStart"]: templateListRequest.displayStart! - templateListRequest.displayLength! })} disabled={templateListRequest.echo == 1} type="link">{t("common.previous")}</Button>
                                                            <Button onClick={() => setTemplateListRequst({ ...templateListRequest, ["echo"]: templateListRequest.echo! + 1, ["displayStart"]: templateListRequest.displayStart! + templateListRequest.displayLength! })} disabled={data?.body?.data?.length == 0} type="link">{t("common.next")}</Button>
                                                        </Flex>
                                                    </Flex>
                                                </div>
                                            </Card>
                                        </Spin>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SFModal
                width={window.innerWidth * 70 / 100}
                open={openMailModal}
                toggler={() => { setOpenMailModal(!openMailModal) }}
                body={<ActionMail previewResponse={mailPreviewData} loading={mailPreviewLoading} onClose={() => setOpenMailModal(false)} spoId={selectedSpo} callback={handleMailCallback} />}
                title={t("action.template.mailTitle")}
            />
        </>
    );
}
